import {ReactNode, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toggleOption} from '~/common/fabric/reducers/giftingOptions/actions';
import {selectGiftingOptions} from '~/ViewInvitation/selectors/gifting';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import {feedbackErrorText} from '~libSass/base/_exports.sass';

interface PhotoGalleryEditorFooterProps {
  onClose: () => void;
  handleSave: () => void;
  primaryActionText: ReactNode;
  isCreationFlow?: boolean;
  photos: Array<{id: string; [key: string]: any}>;
  feedback?: string | null;
}

export const PhotoGalleryEditorFooter = ({
  onClose,
  handleSave,
  primaryActionText,
  isCreationFlow = false,
  photos,
  feedback,
}: PhotoGalleryEditorFooterProps) => {
  const dispatch = useDispatch();
  const isLargishAndUp = useIsLargishAndUp();
  const giftingOptions = useSelector(selectGiftingOptions);

  const removeGallery = useCallback((): void => {
    onClose();
    dispatch(toggleOption(giftingOptions, 'event_option_enable_host_photo_gallery', false));
  }, [onClose, dispatch, giftingOptions]);

  return (
    <>
      {isLargishAndUp && feedback && (
        <Typography
          className="adaptive-modal__footer-feedback"
          variant="paragraph2"
          color="feedbackErrorText"
        >
          <AlertLineIcon color={feedbackErrorText} ratio={0.75} />
          {feedback}
        </Typography>
      )}
      <div className="gallery-editor__footer-actions">
        <Button
          variant="secondary"
          onClick={onClose}
          data-qa-id="gallery-editor-footer-cancel"
          size="large"
          fullWidth
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          data-qa-id="gallery-editor-footer-confirm"
          size="large"
          fullWidth
        >
          {primaryActionText}
        </Button>
      </div>
      {isCreationFlow && photos.length > 0 && (
        <Button
          className="gallery-editor__remove-gallery-btn"
          variant="unstyled-button"
          onClick={removeGallery}
          data-qa-id="gallery-editor-remove-gallery"
          size="large"
          fullWidth
        >
          Remove gallery
        </Button>
      )}
    </>
  );
};
